import { Component, OnInit } from '@angular/core';
import { RunCorrespondenceTasksService } from 'app/services/run-correspondence-tasks.service';
import { RunMaintenanceTasksService } from 'app/services/run-maintenance-tasks.service';


@Component({
  selector: 'app-run-maintenance-tasks',
  templateUrl: './run-maintenance-tasks.component.html',
  styleUrls: ['./run-maintenance-tasks.component.scss']
})
export class RunMaintenanceTasksComponent implements OnInit {

  public lblHeading = 'Evolution Interface';
  public isSynchroniseReportVisible = false;

  public synchroniseAllAccountsReport: any;

  public message = "Processing...";

  public isLoading = false;
  InvoicePermitsReport:any;
  isInvoicePermitsVisible:boolean=false;
  constructor(private service: RunMaintenanceTasksService,private service1: RunCorrespondenceTasksService) { }

  ngOnInit() {

  }
  synchroniseBalance() {
    this.isLoading = true;
    this.service.synchronizeAllAccounts().subscribe(data => {
      this.synchroniseAllAccountsReport = data;
      this.isSynchroniseReportVisible = true;
      this.isLoading = false;
    });

  }
  runInvoicePermitsTask(){
    this.isLoading = true;
    this.service1.InvoicePermits().subscribe(data => {
      this.isLoading = false;
      this.InvoicePermitsReport = data;
      this.isInvoicePermitsVisible = true;
    });
  }
}
